module.exports = __webpack_public_path__ + "static/media/90500.45ae6aaf.png";